import { useEffect, useRef, RefObject } from "react";

export function useDebouncedResizeObserver(
  targetRef: RefObject<HTMLElement | null>,
  callback: () => void,
  delayMs: number = 250
): void {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(() => {
    const target = targetRef.current;
    if (!target) {
      return;
    }
    let timeoutId: number | undefined;
    const observer = new ResizeObserver(() => {
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
      timeoutId = window.setTimeout(() => {
        callbackRef.current();
        timeoutId = undefined;
      }, delayMs);
    });
    observer.observe(target);
    return () => {
      if (timeoutId !== undefined) {
        window.clearTimeout(timeoutId);
      }
      observer.disconnect();
    };
  }, [targetRef, delayMs]);
}
